const SectionCard = ({ title, action, children }) => (
  <div style={{
    background: '#fff', borderRadius: 14,
    border: '1.5px solid #f0f0f5',
    boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
    overflow: 'hidden',
  }}>
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '10px 16px',
      borderBottom: '1px solid #f0f0f5',
    }}>
      <span style={{
        fontSize: 11, fontWeight: 700, letterSpacing: 0.8,
        textTransform: 'uppercase', color: '#9ca3af',
      }}>
        {title}
      </span>
      {action}
    </div>
    <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
      {children}
    </div>
  </div>
);

export default SectionCard;
